import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-white">
      <div className="dm-container py-32 text-center">
        <div className="dm-overline">404 · Not found</div>
        <h1 className="font-serif text-6xl mt-6 text-[var(--dm-navy)]">This page hasn't been engineered yet.</h1>
        <p className="text-[var(--dm-muted)] mt-6 max-w-lg mx-auto">The link may be outdated or mistyped. Try heading back to the homepage.</p>
        <Link to="/" data-testid="notfound-home" className="dm-btn-primary mt-8">Return home</Link>
      </div>
    </section>
  );
}
